import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_ARCHIVE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.archive = payload
  },
  [types.SET_ARCHIVES] (state, payload) {
    state.archives = payload.data
    state.pagination = payload.meta.pagination
  }
}
